import { render, staticRenderFns } from "./GalleryResultsGrid.vue?vue&type=template&id=46270fb8"
import script from "./GalleryResultsGrid.vue?vue&type=script&lang=js"
export * from "./GalleryResultsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports